module.exports = __webpack_public_path__ + "img/logo-text.d5800c31.svg";